module.exports = __webpack_public_path__ + "static/media/mich_and3.f7b86330.jpg";